<template>
  <div class="controls">
    <b-field label="Data Refresh Time (seconds)">
      <b-slider :min="5"
                :max="40"
                v-model="dataRefreshInterval"
                :custom-formatter="formatDataRefreshIntervalLabel" />
    </b-field>
    <b-field label="Volume">
      <b-slider :min="0"
                :max="2"
                :step="0.1"
                v-model="volume"
                :custom-formatter="formatVolumeLabel" />
    </b-field>

    <template v-if="allowRangeSelection && country.length > 1">
      <b-field label="Data range">
        <b-slider :min="0"
                  :max="country.length - 1"
                  v-model="dataRange"
                  :custom-formatter="formatDataRangeLabel"
                  :disabled="playing"/>
      </b-field>
    </template>

    <b-field label="Toggle Radius">
      <b-switch v-model="useRadius"/>
    </b-field>
    <b-field label="Radius (Km)">
      <b-slider :min="0"
                :max="Math.log(20020)"
                :step="0.0001"
                :custom-formatter="formatRadius"
                :disabled="!useRadius"
                lazy
                v-model="radius"
                v-on:dragging="(e)=>changeRadius(e)"
      />
    </b-field>

    <b-field label="Toggle Globe Autorotation">
      <b-switch v-model="autorotation"/>
    </b-field>

    <b-field label="Toggle Transcript">
      <b-switch v-model="transcript"/>
    </b-field>

    <b-field label="Toggle Chart">
      <b-switch v-model="chart"/>
    </b-field>
  </div>
</template>

<script>
import actions from '../../store/actions';

export default {
  name: 'Controls',
  data() {
    return {
      allowRangeSelection: true,
    };
  },
  computed: {
    playing() {
      return this.$store.state.playing;
    },
    dataRefreshInterval: {
      get() {
        return this.$store.state.dataRefreshInterval * 10;
      },
      set(v) {
        this.$store.dispatch(actions.CHANGE_DATA_REFRESH_INTERVAL, v / 10);
      },
    },
    volume: {
      get() {
        return this.$store.state.volume;
      },
      set(v) {
        this.$store.dispatch(actions.CHANGE_VOLUME, v);
      },
    },
    useRadius: {
      get() {
        return this.$store.state.useRadius;
      },
      set(v) {
        this.$store.dispatch(actions.CHANGE_USE_RADIUS, v);
        if (this.$store.state.selectedCountry && v === false) {
          this.$store.dispatch(actions.REFRESH_COUNTRY, v);
        }
      },
    },
    radius: {
      get() {
        return this.$store.state.radius;
      },
      set(v) {
        this.$store.dispatch(actions.CHANGE_RADIUS, v);
        if (this.$store.state.selectedCountry) {
          this.$store.dispatch(actions.REFRESH_COUNTRY, v);
        }
      },
    },
    autorotation: {
      get() {
        return this.$store.state.globeAutorotation;
      },
      set(v) {
        this.$store.dispatch(actions.CHANGE_GLOBE_AUTOROTATION, v);
        this.$store.dispatch(actions.CALL_SET_GLOBE_AUTOROTATION, v);
      },
    },
    transcript: {
      get() {
        return this.$store.state.showTranscript;
      },
      set(v) {
        this.$store.dispatch(actions.CHANGE_SHOW_TRANSCRIPT, v);
      },
    },
    chart: {
      get() {
        return this.$store.state.showChart;
      },
      set(v) {
        this.$store.dispatch(actions.CHANGE_SHOW_CHART, v);
      },
    },
    currentDataIndex() {
      return this.$store.state.currentDataIndex;
    },
    country() {
      return this.$store.state.country;
    },
    dataRange: {
      get() {
        return this.$store.state.dataRange;
      },
      set(range) {
        this.$store.dispatch(actions.CHANGE_DATA_RANGE, range);
      },
    },
  },
  watch: {
    selectedCountry(newCountry) {
      if (newCountry) {
        this.$store.dispatch(actions.LOAD_COUNTRY, { ...newCountry.coordinates });
      }
    },
  },
  methods: {
    play() {
      this.$store.dispatch(actions.PLAY);
    },
    stop() {
      this.$store.dispatch(actions.PAUSE);
    },
    formatDataRefreshIntervalLabel(v) {
      return `${v / 10}`;
    },
    formatDataRangeLabel(idx) {
      return new Date(this.country[idx].day).toDateString();
    },
    formatVolumeLabel(v) {
      return (v * 50).toFixed(0).toString();
    },
    formatRadius(r) {
      return `${Math.ceil(Math.exp(r)).toString()} Km`;
    },
    changeRadius(value) {
      this.$store.dispatch(actions.CHANGE_RADIUS, value);
    },
  },
};
</script>

<style>
.controls {
  z-index: 100;
}
</style>
